import { backgroundColoredColors, textColors, secondaryColors } from '../tokens/color';

export const enecoRibbonColors = {
  ribbonBackgroundMediumEmphasis: backgroundColoredColors.backgroundVarOne,
  ribbonColorMediumEmphasis: textColors.textOnBackgroundVarOne,

  ribbonBackgroundHighEmphasis: secondaryColors.purple900,
  ribbonColorHighEmphasis: textColors.textInverted,
};
